<template>
  <v-container>
      <edit-pst-form :presumptiveData="presumptiveDataEach" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import EditPstForm from "@/components/presumptive/EditPstForm.vue";

export default {
  components: {
   EditPstForm,
  },
  created() {

    EditPstForm    
      this.$store.dispatch(
        "Presumptive/getPresumptiveEach",
        this.$route.params.id
      );
    
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveDataEach"]),
    
  },
  
  methods: {
    createPresumptive(data) {
      console.log(data);
      this.$store.dispatch("Presumptive/createPresumptive", data).then(() => {
        // this.$router.push({
        //   name: "presumptive-list",
        //   params: { township_id: this.$route.params.township_id },
        // });
      });
    },
  },
};
</script>
